module.exports = __webpack_public_path__ + "static/media/chain.58d03280.svg";